var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtComprehensiveInsurance = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 50,
    viewBox: "0 0 85 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m84.981 14.938-.78-2.707c-.262-.905-1.287-1.647-2.255-1.647h-8.594l-7.407-8.438C65.552 1.698 64.693.85 63.077.658 56.344.246 50.097.027 43.88 0h-2.762c-6.212.027-12.46.246-19.196.658-1.616.192-2.475 1.04-2.868 1.488l-7.407 8.438h-8.59c-.969 0-1.993.742-2.256 1.647l-.78 2.707c-.102.354.163.51.518.658l4.896 2.065-1.989 2.265c-1.209 1.42-1.811 3.314-1.765 5.703v22.687C1.682 49.237 2.5 50 3.5 50h12.806c1 0 1.819-.76 1.819-1.684v-4.431h48.748v4.43c0 .929.819 1.685 1.819 1.685h12.806c1 0 1.82-.763 1.82-1.684V25.629c.045-2.389-.554-4.282-1.766-5.703l-1.99-2.265 4.897-2.065c.355-.149.62-.304.518-.658h.003zm-13.242 1.34c-9.57-.5-18.725-.763-27.858-.787h-2.762c-9.133.024-18.288.287-27.858.786-.762.102-.858-.388-.574-.759L21.735 5.08c.397-.455.83-.702 1.468-.773 6.35-.398 12.15-.61 17.912-.64h2.762c5.762.03 11.563.242 17.913.64.638.071 1.07.318 1.468.773l9.051 10.44c.284.37.188.86-.574.758h.004z",
    fill: "#1B7690",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 20h21v21H32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.48 27.846h-.537v-2.149a4.302 4.302 0 0 0-4.297-4.297 4.302 4.302 0 0 0-4.297 4.297v2.149h-.538c-.888 0-1.611.722-1.611 1.611v7.52c0 .89.723 1.612 1.611 1.612h9.67c.887 0 1.61-.723 1.61-1.611v-7.52c0-.89-.723-1.612-1.61-1.612zm-7.699-2.149a2.868 2.868 0 0 1 2.865-2.865 2.868 2.868 0 0 1 2.865 2.865v2.149h-5.73v-2.149z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtComprehensiveInsurance);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-comprehensive-insurance.e4b7ec71acd7cfd924ee530bc3612d72.svg";